<form style="text-align: left; margin-bottom: 15px;" novalidate [formGroup]="globalData.ristoranteDispForm">

    <input formControlName="data" [class.error1]="!globalData.ristoranteDispForm.controls.data.valid && globalData.ristoranteDispForm.controls.data"
        autocomplete="off" class="form-control datepicker-custom" (click)="datePickerIdAdd.toggle()" placeholder="gg-mm-aaaa"
        [(ngModel)]="globalData.dataDispRistorante" ngbDatepicker #datePickerIdAdd="ngbDatepicker">
    <div no-lines *ngIf="globalData.ristoranteDispForm.get('data').hasError('required')  && globalData.ristoranteDispForm.get('data').touched">
        <div style="color: red !important" class="error" *ngIf="globalData.ristoranteDispForm.get('data').hasError('required') && globalData.ristoranteDispForm.get('data').touched">
            Selezionare il giorno della prenotazione
        </div>
    </div>
</form>